import { Column, Entity, JoinColumn, JoinTable, ManyToOne, OneToMany, OneToOne } from 'typeorm';
import { GenericModel } from '@nsk-app/models/genericModel';
import { Hospital } from '@nsk-app/models/hospital';
import { ContactElement } from '@nsk-app/models/contactElement';
import { MediaFile } from '@nsk-app/models/mediaFile';

@Entity()
export class ContactInformation extends GenericModel {

  @Column()
  site_contact: boolean;

  @Column()
  hospital_site_id: number;

  @Column({nullable: true})
  media_id?: number;

  @ManyToOne(type => Hospital, hospital => hospital.contacts, {lazy: true})
  @JoinColumn({name: 'hospital_site_id'})
  hospital: Promise<Hospital>;

  @OneToMany(type => ContactElement, element => element.contact, {eager: true, cascade: ['insert', 'update']})
  elements: ContactElement[];

  @ManyToOne(type => MediaFile, {eager: true})
  @JoinColumn({name: 'media_id'})
  image?: MediaFile;
}
